export default class Events {

    constructor($timeout) {
        this._timeout = $timeout;
        this.events = [];
    }

    getEvents() {
        return this.events;
    };

    hasEvents() {
        return this.events.length > 0;
    };

    flashEvent(type, message) {
        var addedTime = 0;

        if (this.hasEvents()) {
            addedTime += 500
        }

        this._timeout(() => {
            this.events.push({ type: type, message: message });
        }, addedTime);

        this._timeout(() => {
            this.events.shift()
        }, 5000 + addedTime)
    };
};

Events.$inject = ['$timeout'];
